import { JSX } from 'react'

import { IconProps } from '../../icon'

const Grades: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M39.1471 13.4918L35.0268 9.3715C34.9086 9.2533 34.7566 9.15198 34.5878 9.08443C34.5202 9.06755 34.4527 9.06755 34.402 9.05066C34.3176 9.03377 34.2332 9 34.1487 9H13.8682C13.7837 9 13.6993 9.03377 13.6149 9.05066C13.5473 9.05066 13.4798 9.05066 13.4291 9.08443C13.2603 9.15198 13.1083 9.23641 12.9901 9.3715L8.8698 13.4918C7.89039 14.4712 7.72152 15.9741 8.44764 17.1561L16.0972 29.3988C16.0465 29.7703 15.979 30.1418 15.979 30.547C15.979 34.9713 19.5758 38.5681 24 38.5681C28.4242 38.5681 32.021 34.9713 32.021 30.547C32.021 30.1586 31.9535 29.7871 31.9028 29.3988L39.5524 17.1561C40.2785 15.9741 40.1096 14.4712 39.1302 13.4918H39.1471ZM24 22.5091C23.6792 22.5091 23.3752 22.5598 23.0712 22.6104L20.3694 18.2875H27.6137L24.9119 22.6104C24.6079 22.5767 24.304 22.5091 23.9831 22.5091H24ZM29.201 15.7883C29.201 15.7883 29.1166 15.7546 29.0659 15.7546H18.9341C18.9341 15.7546 18.8497 15.7714 18.799 15.7883L16.1478 11.533H31.8353L29.1841 15.7883H29.201ZM10.5922 15.8052C10.4909 15.6364 10.5078 15.4168 10.6598 15.2817L13.6486 12.2928L20.5552 23.3365C19.1705 24.012 18.0053 25.059 17.1948 26.3592L10.5922 15.8052ZM24 36.0182C20.9773 36.0182 18.5119 33.5528 18.5119 30.5301C18.5119 27.5075 20.9773 25.0421 24 25.0421C27.0227 25.0421 29.4881 27.5075 29.4881 30.5301C29.4881 33.5528 27.0227 36.0182 24 36.0182ZM37.4078 15.8052L30.8052 26.3592C29.9947 25.059 28.8464 23.9951 27.4448 23.3365L34.3514 12.2928L37.3402 15.2817C37.4753 15.4168 37.5091 15.6364 37.4078 15.8052Z'
      fill='black'
    />
  </svg>
)

export default Grades
